import supportingCommentaryPdfService from './supportingCommentaryPdf.service';
import signaturesPdfService from './signaturesPdf.service';
import privacyDisclosureStatementService from './privacyDisclosureStatement.service';
import preferredProductService from './preferredProductPdf.service';
import pdfService from './pdf.service';
import otherAdvisersPdfService from './otherAdvisersPdf.service';
import objectivesPdfService from './objectivesPdf.service';
import liabilitiesPdfService from './liabilitiesPdf.service';
import incomePdfService from './incomePdf.service';
import householdsPdfService from './householdsPdf.service';
import homeLoanSecuritiesPdfService from './homeLoanSecuritiesPdf.service';
import homeLoanRefinanceAnalysisPdfService from './homeLoanRefinanceAnalysisPdf.service';
import homeLoanMaximumBorrowingPdfService from './homeLoanMaximumBorrowingPdf.service';
import homeLoanFundingWorksheetPdfService from './homeLoanFundingWorksheetPdf.service';
import homeLoanFeesAndChargesPdfService from './homeLoanFeesAndChargesPdf.service';
import homeLoanCompareProductsPdfService from './homeLoanCompareProductsPdf.service';
import helperPdfService from './helperPdf.service';
import financialPositionPdfService from './financialPositionPdf.service';
import expensesPdfService from './expensesPdf.service';
import contactPdfService from './contactPdf.service';
import businessDetailsPdfService from './businessDetailsPdf.service';
import assetsPdfService from './assetsPdf.service';
import assetsAndLiabilitiesPdfService from './assetsAndLiabilitiesPdf.service';
import assetFinanceFinanceProposalPdfService from './assetFinanceFinanceProposalPdf.service';
import assetFinanceAssetToBeFinancedPdfService from './assetFinanceAssetToBeFinancedPdf.service';
import assetFinanceAmortizationSchedulePdfService from './assetFinanceAmortizationSchedulePdf.service';
import assetFinanceCompareProductsPdfService from './assetFinanceCompareProductsPdf.service';
import assetCommitmentSchedulePdfService from './assetCommitmentSchedulePdf.service';
import applicationFormPdfService from './applicationFormPdf.service';
import acknowledgementAndDeclarationPdfService from './acknowledgementAndDeclarationPdf.service';
import aboutUsDetailsPdfService from './aboutUsDetailsPdf.service';
import abilityToServicePdfService from './abilityToServicePdf.service';

export default angular
  .module('st.Pdf', ['st.Core'])
  .service('supportingCommentaryPdfService', supportingCommentaryPdfService)
  .service('signaturesPdfService', signaturesPdfService)
  .service('privacyDisclosureStatementService', privacyDisclosureStatementService)
  .service('preferredProductService', preferredProductService)
  .service('pdfService', pdfService)
  .service('otherAdvisersPdfService', otherAdvisersPdfService)
  .service('objectivesPdfService', objectivesPdfService)
  .service('liabilitiesPdfService', liabilitiesPdfService)
  .service('incomePdfService', incomePdfService)
  .service('householdsPdfService', householdsPdfService)
  .service('homeLoanSecuritiesPdfService', homeLoanSecuritiesPdfService)
  .service('homeLoanRefinanceAnalysisPdfService', homeLoanRefinanceAnalysisPdfService)
  .service('homeLoanMaximumBorrowingPdfService', homeLoanMaximumBorrowingPdfService)
  .service('homeLoanFundingWorksheetPdfService', homeLoanFundingWorksheetPdfService)
  .service('homeLoanFeesAndChargesPdfService', homeLoanFeesAndChargesPdfService)
  .service('homeLoanCompareProductsPdfService', homeLoanCompareProductsPdfService)
  .service('helperPdfService', helperPdfService)
  .service('financialPositionPdfService', financialPositionPdfService)
  .service('expensesPdfService', expensesPdfService)
  .service('contactPdfService', contactPdfService)
  .service('businessDetailsPdfService', businessDetailsPdfService)
  .service('assetsPdfService', assetsPdfService)
  .service('assetsAndLiabilitiesPdfService', assetsAndLiabilitiesPdfService)
  .service('assetFinanceFinanceProposalPdfService', assetFinanceFinanceProposalPdfService)
  .service('assetFinanceAssetToBeFinancedPdfService', assetFinanceAssetToBeFinancedPdfService)
  .service(
    'assetFinanceAmortizationSchedulePdfService',
    assetFinanceAmortizationSchedulePdfService
  )
  .service('assetFinanceCompareProductsPdfService', assetFinanceCompareProductsPdfService)
  .service('assetCommitmentSchedulePdfService', assetCommitmentSchedulePdfService)
  .service('applicationFormPdfService', applicationFormPdfService)
  .service('acknowledgementAndDeclarationPdfService', acknowledgementAndDeclarationPdfService)
  .service('aboutUsDetailsPdfService', aboutUsDetailsPdfService)
  .service('abilityToServicePdfService', abilityToServicePdfService)
  .constant('PDF', {
    PDF_TYPES: [
      'APPLICATION_FORM',
      'PRIVACY_DISCLOSURE_STATEMENT_AND_CONSENT',
      'HOME_LOAN_FUNDING_WORKSHEET',
      'HOME_LOAN_MAXIMUM_BORROWING',
      'HOME_LOAN_COMPARE_PRODUCTS',
      'HOME_LOAN_REFINANCE_ANALYSIS',
      'HOME_LOAN_FEES_AND_CHARGES',
      'ASSET_FINANCE_AMORTIZATION_SCHEDULE',
      'ASSET_FINANCE_COMPARE_PRODUCTS'
    ]
  });
